import { createVanIconComponent } from "./van"

const WechatPay = createVanIconComponent("wechat-pay")
export default WechatPay
